var exports = {
  "b": "Testimonials__aI2Mbi",
};

module.exports = exports;
